import { trackPromise } from 'react-promise-tracker';
import api from '../utils/API';

const MAX_QUERY_SIZE = 1000;
const DEFAULT_QUERY_SIZE = 20;

const getClientId = () => JSON.parse(localStorage.getItem('cliente'))?.codigo;

const normalizeFilterParams = params => {
  if (!params) return {};
  if (typeof params === 'string') return { query: params };
  return params;
};

const pickFilledFilterParams = params => {
  const normalizedParams = normalizeFilterParams(params);

  return {
    ...(normalizedParams.query && { query: normalizedParams.query }),
    ...(normalizedParams.categoryLevel1?.length && { categoryLevel1: normalizedParams.categoryLevel1 }),
    ...(normalizedParams.categoryLevel2?.length && { categoryLevel2: normalizedParams.categoryLevel2 }),
    ...(normalizedParams.categoryLevel3?.length && { categoryLevel3: normalizedParams.categoryLevel3 }),
    ...(normalizedParams.categoryLevel4?.length && { categoryLevel4: normalizedParams.categoryLevel4 }),
    ...(normalizedParams.categoryLevel5?.length && { categoryLevel5: normalizedParams.categoryLevel5 }),
    ...(normalizedParams.categoryLevel6?.length && { categoryLevel6: normalizedParams.categoryLevel6 }),
    ...(normalizedParams.categoryLevel7?.length && { categoryLevel7: normalizedParams.categoryLevel7 }),
    ...(normalizedParams.description?.length && { description: normalizedParams.description }),
    ...(normalizedParams.productId?.length && { productId: normalizedParams.productId }),
    ...(normalizedParams.productFamilyId?.length && { productFamilyId: normalizedParams.productFamilyId }),
    ...(normalizedParams.gtin?.length && { gtin: normalizedParams.gtin }),
    ...(normalizedParams.abcClass?.length && { abcClass: normalizedParams.abcClass }),
  };
};

const removeEmptyValues = params =>
  Object.entries(params).reduce((data, [key, value]) => {
    if (Array.isArray(value) && !value.length) return data;
    if (value === undefined || value === null || value === '') return data;
    return {
      ...data,
      [key]: value,
    };
  }, {});

export const getFamiliaPrecificacao = productFamilyId =>
  trackPromise(
    api({
      url: `${process.env.REACT_APP_IPA_URL}/products/families/id`,
      method: 'POST',
      expectToken: true,
      params: {
        size: 10,
      },
      data: {
        ...(productFamilyId && {
          query: productFamilyId,
        }),
      },
    }).then(resp => resp?.data),
  );

export const getProdutoCliente = query =>
  trackPromise(
    api({
      url: `${process.env.REACT_APP_CADASTROS_API_URL}/contratos/clientes/produtos/search`,
      method: 'GET',
      params: {
        query: query.query,
      },
      expectToken: true,
    }).then(resp => resp?.data),
    'produto-cliente-service',
  );

export const getSegmentos = () =>
  trackPromise(
    api({
      url: `${process.env.REACT_APP_IPA_URL}/setup/categories`,
      params: {
        clientId: getClientId(),
      },
      expectToken: true,
      method: 'GET',
    }).then(resp => resp.data),
  );

export const getSegmentosClasses = () =>
  api({
    url: `${process.env.REACT_APP_IPA_URL}/setup/categories/classes`,
    method: 'GET',
    expectToken: true,
    params: {
      clientId: getClientId(),
    },
  }).then(resp => resp.data);

export const getSegmentosSensibilities = () =>
  api({
    url: `${process.env.REACT_APP_IPA_URL}/setup/categories/sensibilities`,
    method: 'GET',
    expectToken: true,
    params: {
      clientId: getClientId(),
    },
  }).then(resp => resp.data);

export const getItensSegmentoProduto = (nivel, params = {}) => {
  const normalizedParams = normalizeFilterParams(params);

  return api({
    url: `${process.env.REACT_APP_IPA_URL}/products/filters`,
    method: 'POST',
    expectToken: true,
    params: {
      clientId: getClientId(),
      size: normalizedParams.size ? normalizedParams.size : DEFAULT_QUERY_SIZE,
    },
    data: {
      field: nivel || null,
      ...pickFilledFilterParams(normalizedParams),
    },
  }).then(resp => resp.data);
};

export const searchFiltroProdutos = (params = {}) => {
  const { query = '', size = DEFAULT_QUERY_SIZE, isModal = false, productFamilyId, ...rest } = normalizeFilterParams(params);

  return api({
    url: `${process.env.REACT_APP_IPA_URL}/products/search`,
    method: 'POST',
    expectToken: true,
    params: {
      clientId: getClientId(),
      query,
      size: isModal ? MAX_QUERY_SIZE : size,
      isModal,
    },
    data: removeEmptyValues({
      ...rest,
      ...(productFamilyId?.length && { productFamilyIds: productFamilyId }),
    }),
  }).then(resp => resp.data);
};

export const getQtdProdutosAfetados = query =>
  api({
    url: 'http://54.208.158.73:8080/produtos/qtd',
    method: 'POST',
    data: JSON.stringify({
      nivel_1: query && query.nivel_1 && query.nivel_1.length ? query.nivel_1 : null,
      nivel_2: query && query.nivel_2 && query.nivel_2.length ? query.nivel_2 : null,
      nivel_3: query && query.nivel_3 && query.nivel_3.length ? query.nivel_3 : null,
      nivel_4: query && query.nivel_4 && query.nivel_4.length ? query.nivel_4 : null,
      nivel_5: query && query.nivel_5 && query.nivel_5.length ? query.nivel_5 : null,
      nivel_6: query && query.nivel_6 && query.nivel_6.length ? query.nivel_6 : null,
      nivel_7: query && query.nivel_7 && query.nivel_7.length ? query.nivel_7 : null,
      nivel_8: query && query.nivel_8 && query.nivel_8.length ? query.nivel_8 : null,
      nivel_9: query && query.nivel_9 && query.nivel_9.length ? query.nivel_9 : null,
    }),
  }).then(resp => resp.data);

export const getLastUpdate = () =>
  api({
    url: `${process.env.REACT_APP_IPA_URL}/products/last-update`,
    method: 'GET',
    expectToken: true,
    params: {
      clientId: getClientId(),
    },
  }).then(resp => resp.data);

export const getCompetitorsPrices = (productId, clientId, storeId) =>
  trackPromise(
    api({
      url: `${process.env.REACT_APP_IPA_URL}/competitor/prices/${productId}`,
      params: {
        clientId: clientId || getClientId(),
        storeId: storeId || 1,
      },
      method: 'GET',
      expectToken: true,
    }).then(resp => resp.data),
  );
